/* eslint-disable */
// COOKIE
export function getCookie(name) {
  const cookies = document.cookie ? document.cookie.split(';') : [];
  for (let i = 0; i < cookies.length; i++) {
    const parts = cookies[i].split('=');
    const key = decodeURIComponent(parts.shift().trim());
    const value = parts.join('=');
    if (key === name) {
      const decoded = decodeURIComponent(value);
      return decoded;
    }
  }
  return null;
}